// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"79":"2eda8b8e","655":"5ff22e5c","727":"5fc00619","853":"766e9e22"}[chunkId] + ".chunk.css";
};